var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$lodash.has(this.ask, "text")
    ? _c(
        "md-card",
        [
          _c(
            "md-ripple",
            { staticClass: "ask-content" },
            [
              _c(
                "md-card-header",
                { staticClass: "positiveresponse-outer" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "remove-link",
                      attrs: { to: "/asks/" + _vm.ask._id + "/request" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ask-subject",
                          style: _vm.communityStyle
                        },
                        [
                          _c("ul", { staticClass: "list-inline mb-0" }, [
                            _c("li", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$lodash.has(_vm.community, "name")
                                      ? _vm.community.name +
                                          ": " +
                                          (_vm.currentAsk.subject
                                            ? _vm.currentAsk.subject
                                            : "N/A")
                                      : _vm.currentAsk.subject
                                      ? _vm.currentAsk.subject
                                      : "N/A"
                                  ) +
                                  "\n                "
                              ),
                              _vm.currentAsk.matchingCriteria &&
                              _vm.currentAsk.matchingCriteria.assignment &&
                              _vm.currentAsk.matchingCriteria.assignment
                                .autoRefill === true
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "vertical-align": "middle",
                                        "margin-left": "6px"
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle"
                                          },
                                          attrs: {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 24 24",
                                            fill: "#004D40"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.currentAsk.comments.length
                              ? _c("li", { staticClass: "count" }, [
                                  _vm._v(_vm._s(_vm.currentAsk.comments.length))
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "positiveresponse",
                      style: _vm.communityStyle
                    },
                    [
                      _vm.selectedOwner != "" &&
                      _vm.currentAsk.status != "(7) Closed" &&
                      _vm.currentAsk.status != "(8) Rejected"
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.selectedOwner) + ")     ")
                          ])
                        : _vm._e(),
                      _vm._v(
                        _vm._s(_vm.positiveResponse) +
                          " / " +
                          _vm._s(_vm.recommendedAdvisors)
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("md-card-content", [
                _c("div", { staticClass: "md-subhead" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c("ul", { staticClass: "list-unstyled mb-0" }, [
                        _c("li", [
                          _vm._v("Status: " + _vm._s(_vm.currentAsk.status))
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Received: " +
                              _vm._s(_vm._f("momentDate")(_vm.ask.createdAt))
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v("Last Advisor Matched:\n                  "),
                          _vm.ask.matchAdviserDate
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentDate")(
                                      _vm.ask.matchAdviserDate
                                    )
                                  )
                                )
                              ])
                            : _c("span", [_vm._v("N/A")])
                        ]),
                        _vm._v(" "),
                        _vm.ask.dueDate
                          ? _c("li", { staticClass: "ask-dueDate" }, [
                              _vm._v(
                                "Due Date: " +
                                  _vm._s(_vm._f("dateFormat")(_vm.ask.dueDate))
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "ul",
                        { staticClass: "list-unstyled pull-right mb-0" },
                        [
                          _c("li", [
                            _vm.$lodash.has(_vm.createdByMember, "displayName")
                              ? _c("span", [
                                  _vm._v(
                                    "Sender: " +
                                      _vm._s(_vm.createdByMember.displayName)
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.$lodash.has(_vm.createdByMember, "emails")
                              ? _c("span", [
                                  _vm._v(
                                    "Email: " +
                                      _vm._s(
                                        _vm.createdByMember.emails.toString()
                                      )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "mt-10",
                  domProps: {
                    innerHTML: _vm._s(_vm.nl2br(_vm.ask.text.substring(0, 500)))
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-378bf651", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378bf651","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AskRow.vue
// module id = null
// module chunks = 